import React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Link } from 'react-router-dom';
import Tooltip from '@material-ui/core/Tooltip';

import { ApiHelper } from '../../../common/helpers/ApiHelper';
import { Helper } from '../../../common/helpers/Helper';
import { BaseEntityPage } from '../../../common/components/BaseEntityPage';
import { UiHelper } from '../../../common/helpers/UiHelper';
import { AppStyles } from '../../../styles/AppTheme';
const vsprintf = require('sprintf-js').vsprintf

export class CoTypes extends BaseEntityPage {

  constructor(props) {
    super(props);
    this.pageTitle = Helper.getString('cotypes')
    this.orgId = this.props.match.params.orgId
    this.breadCrumbs = [
      { title: Helper.getString('home'), to: this.baseRoute() },
      { title: Helper.getString('cotypes') },
    ]
    this.toFetch = [
      { method: 'GET', endPoint: ApiHelper.makeUrlPath(['cotypes'], { orgId: this.orgId, pb: 'fieldDef' }) },
    ]
    this.tableHeadersMap = {
      Index: (current) => current.__index + 1,
      Info: (current) => {
        return (
          <div>
            <span className={css(Styles.spanValue)}>{current.title}</span>
            {/* <br/>
            <span className={css(Styles.spanValue)}>Helper.formatTimestamp(current.createdTs)</span> */}
            <br/>
          </div>
        )
      }
    }
    this.tableHeaders = Object.keys(this.tableHeadersMap)
    this.apiData = {
      orgId: this.orgId
    }
    // this.headerActions = [
    //   {
    //     label: 'Refresh',
    //     icon: 'refresh',
    //     onClick: () => this.fetchItems()
    //   },
    //   {
    //     label: 'New Custom Oject',
    //     onClick: () => this.openModalForAdd()
    //   },
    // ]
  }

  onFetchSuccess(results) {
    this.fieldDef = this.formDefinition = results[0].fieldDef
    this.setState({
      items: results[0].items,
    })
  }

  onTableValue(current, index) {
    if (!this.tableHeaders[index]) { return '' }
    return this.tableHeadersMap[this.tableHeaders[index]](current)
  }

  onAdd() {
    this.setState({
      apiMethod: 'POST',
      apiEndPoint: ApiHelper.makeUrlPath(['cotypes']),
    });
  }

  onEdit(current) {
    this.setState({
      apiMethod: 'PUT',
      apiEndPoint: ApiHelper.makeUrlPath(['cotypes', current.id]),
    });
  }

  onDelete(current) {
    this.setState({
      apiMethod: 'DELETE',
      apiEndPoint: ApiHelper.makeUrlPath(['cotypes', current.id], {}),
    });
  }

  onActions(current) {
    const actions = []
    actions.push(
      <Link to={this.baseRoute() + '/cotypes/' + current.id + '/fields'} key={current.id + '-fields'}>
        <Tooltip title='Fields' placement='top-start'>
          <span className={css(AppStyles.entityTableLinkIcon)}>
            <i className='material-icons-outlined'>format_list_numbered</i>
          </span>
        </Tooltip>
      </Link>
    )
    actions.push(UiHelper.buttonEdit(this, current))
    actions.push(UiHelper.buttonDelete(this, current))
    // actions.push(
    //   <Link to={this.baseRoute() + '/cotypes/' + current.id + '/items'} key={current.id + '-items'}>
    //     <Tooltip title={Helper.getString('cos')} placement='top-start'>
    //       <span className={css(AppStyles.entityTableLinkIcon)}>
    //         <i className='material-icons-outlined'>dataset</i>
    //       </span>
    //     </Tooltip>
    //   </Link>
    // )
    return actions
  }
}

const Styles = StyleSheet.create({
  spanValue: {
    fontSize: 16
  }
})